import React, { useState } from 'react';

/**
 * The waving-Texas mascot when /logo.png exists in client/public, otherwise a
 * magenta monogram. Drop the PNG in and every logo slot picks it up.
 */
export default function BrandLogo({ size = 40, className = '', rounded = true }: { size?: number; className?: string; rounded?: boolean }) {
  const [missing, setMissing] = useState(false);
  if (missing) {
    return (
      <div className={`flex items-center justify-center bg-brand-600 text-black font-black ${rounded ? 'rounded-2xl' : ''} ${className}`}
        style={{ width: size, height: size, fontSize: size * 0.5 }}>K</div>
    );
  }
  return (
    <img src="/logo.png" alt="Keep Austin Mowed" width={size} height={size}
      className={`object-contain ${className}`} style={{ width: size, height: size }}
      onError={() => setMissing(true)} />
  );
}
